let sellingPlanGroups = {}
const selectedPlanClass = "custom-selected-plan";

function changeSelectedPlan(formId, selectedPlan){
    sellingPlanGroups[formId].forEach((plan) => {
        plan.classList.remove(selectedPlanClass)
    });

    selectedPlan.classList.add(selectedPlanClass);
    selectedPlan.changeBuyButtonPrice();
}

function addSellingPlanToGroup(formId, sellingPlan){
    if(sellingPlanGroups[formId]){
    } else {
      sellingPlanGroups[formId] = [];
    }

    sellingPlanGroups[formId].push(sellingPlan);
    if(sellingPlanGroups[formId].length === 1){
        sellingPlan.setSellingPlan();
        changeSelectedPlan(formId, sellingPlan);
    }
}